import axios, { AxiosError } from 'axios';
import store from 'store';

import { useQuery } from '@tanstack/react-query';

const getProposalSupervisorsList: {
  (): Promise<any>;
} = async () => {
  const header = {
    Authorization: `Token ${store.getState().user.token}`,
  };

  const res = await axios({
    baseURL:
      process.env.REACT_APP_ADSERVER_ENDPOINT +
      '/proposals/publishersupervisors',
    method: 'GET',
    headers: header,
  });
  return res;
};

export const useGetProposalSupervisorsList = (): {
  data: any;
  status: string;
  isLoading: boolean;
} => {
  const { data, status, isLoading } = useQuery<any, AxiosError>({
    queryKey: ['proposalSupervisorList'],
    queryFn: () => getProposalSupervisorsList(),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    data,
    status,
    isLoading,
  };
};

const getCurrentProposalSupervisorsList: {
  (id: number): Promise<any>;
} = async id => {
  const header = {
    Authorization: `Token ${store.getState().user.token}`,
  };

  const res = await axios({
    baseURL: process.env.REACT_APP_ADSERVER_ENDPOINT + `/proposal/${id}/users`,
    method: 'GET',
    headers: header,
  });
  return res;
};

export const useGetCurrentProposalSupervisorsList = (
  id: number,
  options?: { enabled?: boolean },
): {
  data: any;
  status: string;
  isLoading: boolean;
} => {
  const { data, status, isLoading } = useQuery<any, AxiosError>({
    queryKey: ['currentProposalSupervisorList', id],
    queryFn: () => getCurrentProposalSupervisorsList(id),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options,
  });

  return {
    data,
    status,
    isLoading,
  };
};
